import { createClient } from '@supabase/supabase-js';

// Required — see .env.example. No hardcoded fallback: a missing env var
// must fail loudly here rather than silently connecting to whatever
// project happened to be baked in as a default.
const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON) {
  throw new Error(
    'Missing Supabase configuration. Set REACT_APP_SUPABASE_URL and ' +
    'REACT_APP_SUPABASE_ANON_KEY in a .env file at the project root ' +
    '(copy .env.example to .env and fill in the values), then restart ' +
    'the dev server. These are required — there is no default project ' +
    'to fall back to.'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'ffn-auth-token',
  },
});
